const DATE_PREFIX = /^\d{8}_/
const ID_PREFIX = /^E\d+_/

/** Reconnaît un code programme préfixé par une date (`AAAAMMJJ_`) ou par un ID d'édition (`E{n}_`). */
export function hasProgramCodePrefix(code: string): boolean {
  return DATE_PREFIX.test(code) || ID_PREFIX.test(code)
}

/** Retire le préfixe présent (date ou ID), quel que soit son format. */
export function stripProgramCodePrefix(code: string): string {
  return code.replace(DATE_PREFIX, '').replace(ID_PREFIX, '')
}

/** Un code en mode ID désigne une édition inédite, sans date de diffusion connue. */
export function isIdCodedProgramCode(code: string | null | undefined): boolean {
  const trimmed = code?.trim().toUpperCase()
  return !!trimmed && ID_PREFIX.test(trimmed)
}

export function buildIdProgramCode(baseCode: string, editionSeq: number): string {
  return `E${editionSeq}_${baseCode}`
}
